import type { FaireProductEntity } from "../../entity_types/product";

export const p_28ocoknq: FaireProductEntity = {
  token: "p_28ocoknq",
  type: "product",
  name: "Golden Coast - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/931a31a74b754feeff09a1a9d1a3ae20524f5dfc590e6713e268b5e1d8dd7f77.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a74855f068a1f0f3c6a92011ce08d91c783f79782ad5a832fd60d972b3f61e0d.jpeg",
    "https://cdn.faire.com/fastly/23e5158babf4f282b28fd359e61265add78498a2afc7b73610539350bb2cc769.jpeg",
    "https://cdn.faire.com/fastly/66fea94051f5eedd2695c95c86cbef836213c1d28356e9fe06fc561bc88f9947.jpeg",
    "https://cdn.faire.com/fastly/33dc47d37698aed017cd2303808ec585cdfd016104910b6f319d1209f8fb2e0e.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "Big Sur magic, wild sage baking in the sun, the rumble of waves and rocks. Notes of eucalyptus, sea salt, redwood, and palo santo.\n\nThis is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\n Our best-selling 7.2 oz Standard Size.This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:55.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
